var map = {
	"./43.mp3": "6524",
	"./44.mp3": "2275",
	"./45.mp3": "81dc",
	"./46.mp3": "f2f2",
	"./47.mp3": "65c9",
	"./48.mp3": "69c5",
	"./49.mp3": "d551",
	"./50.mp3": "58cd",
	"./51.mp3": "358c",
	"./52.mp3": "5bd7",
	"./53.mp3": "45dd",
	"./54.mp3": "e72a",
	"./55.mp3": "2bc5",
	"./56.mp3": "db91",
	"./M_Brilliant.mp3": "e522",
	"./M_Excellent.mp3": "45b8",
	"./M_Fantastic.mp3": "869b",
	"./M_Great.mp3": "3bed",
	"./M_Perfect.mp3": "d489",
	"./M_Think again.mp3": "e5f3",
	"./M_Try again.mp3": "8143",
	"./M_Very good.mp3": "2599",
	"./M_Well done.mp3": "da10",
	"./M_Work harder.mp3": "efba",
	"./click.mp3": "1239",
	"./false.mp3": "d9d6",
	"./true.mp3": "3916"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "063c";